import { MerchantOverrides } from "@redotech/redo-customer-portal-shared/hooks/useReview/use-merchant-overrides";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { Flex } from "@redotech/redo-web/flex";
import { useState } from "react";
import { MerchantOverrideAdjustmentModal } from "./merchant-override-adjustment-modal";

export interface MerchantOverrideItemAdjustmentsDisplayProps {
  overrides: MerchantOverrides;
  pendingReturnItemId: string | undefined;
  itemReturnValue?: number;
  isAdjustmentModalOpen: boolean;
  onOpenAdjustmentModal: () => void;
  onCloseAdjustmentModal: () => void;
}

export const MerchantOverrideItemAdjustmentsDisplay = ({
  overrides,
  pendingReturnItemId,
  itemReturnValue,
  isAdjustmentModalOpen,
  onOpenAdjustmentModal,
  onCloseAdjustmentModal,
}: MerchantOverrideItemAdjustmentsDisplayProps) => {
  if (!overrides || !pendingReturnItemId || itemReturnValue === undefined) {
    return null;
  }
  const { texts, inputs, permissions } = overrides;
  return (
    <Flex flexDirection="column" gap="lg">
      {permissions.canEditFeesAndBonuses && (
        <Flex style={{ width: "155px" }}>
          <RedoButton
            disabled={!inputs.enabled}
            hierarchy="secondary"
            onClick={onOpenAdjustmentModal}
            size="sm"
            text={texts.adjustFeeButton}
          />
        </Flex>
      )}
      {permissions.canEditGreenReturns && (
        <RedoToggle
          description={texts.greenReturnDescription}
          disabled={!inputs.enabled}
          label={texts.greenReturn}
          setValue={(value) =>
            inputs.onChangeGreenReturnOverride(pendingReturnItemId, value)
          }
          size="sm"
          testId="green-return-toggle"
          value={inputs.greenReturnOverrides.get(pendingReturnItemId) ?? false}
        />
      )}
      {isAdjustmentModalOpen && permissions.canEditFeesAndBonuses && (
        <MerchantOverrideAdjustmentModal
          isOpen={isAdjustmentModalOpen}
          itemReturnValue={itemReturnValue}
          onClose={onCloseAdjustmentModal}
          overrides={overrides}
          pendingReturnItemId={pendingReturnItemId}
        />
      )}
    </Flex>
  );
};

export const MerchantOverrideItemAdjustments = ({
  overrides,
  pendingReturnItemId,
  itemReturnValue,
}: {
  overrides: MerchantOverrides;
  pendingReturnItemId: string | undefined;
  itemReturnValue?: number;
}) => {
  const [isAdjustmentModalOpen, setIsAdjustmentModalOpen] = useState(false);

  return (
    <MerchantOverrideItemAdjustmentsDisplay
      isAdjustmentModalOpen={isAdjustmentModalOpen}
      itemReturnValue={itemReturnValue}
      onCloseAdjustmentModal={() => setIsAdjustmentModalOpen(false)}
      onOpenAdjustmentModal={() => setIsAdjustmentModalOpen(true)}
      overrides={overrides}
      pendingReturnItemId={pendingReturnItemId}
    />
  );
};
